import {$} from './jquery-definition.js';
import SmoothScroll from 'smooth-scroll';
import '@fancyapps/fancybox';

var smoothScroll = new SmoothScroll( 'a[href*="#"]', {
	topOnEmptyHash: false,
	updateURL: false,
	speed: 1000,
	speedAsDuration: true
} );

var navTimeouts = [];

$( function() {
	sanitizeTargetBlank();

	// Add classes based on scroll position/direction
	var $html = $( 'html' );
	var lastScroll = 0;
	var newScroll = 0;
	var menuAutoHider;

	$( window ).on( 'scroll', function( event ) {
		newScroll = $( window ).scrollTop();
		clearTimeout( menuAutoHider );

		if ( newScroll > 0 && !$( 'body' ).hasClass( 'active-navigation' ) ) {
			$html.removeClass( 'at-top' );

			if ( newScroll > lastScroll + 30 ) {
				$html.removeClass( 'scrolled-up' );
				$html.addClass( 'scrolled-down' );
				lastScroll = newScroll;
			} else if ( newScroll < lastScroll - 30 ) {
				$html.addClass( 'scrolled-up' );
				$html.removeClass( 'scrolled-down' );

				menuAutoHider = setTimeout( function() {
					$html.removeClass( 'scrolled-up' ).addClass( 'scrolled-down' );
				}, 5000 );
				lastScroll = newScroll;
			}
		} else {
			$html.removeClass( 'scrolled-up' ).removeClass( 'scrolled-down' ).addClass( 'at-top' );
		}
	} );

	// Toggle
	$( '.toggle' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();

		var $this = $( this );
		var $target = $( $this.attr( 'data-target' ) );

		$this.toggleClass( 'active' );
		$target.toggleClass( 'active' );
		$( 'body' ).toggleClass( $this.attr( 'data-body-class' ) );

		if ( !$this.hasClass( 'site-navigation-control' ) ) {
			closeMenu();
		}
	} );

	$( '.site-navigation-control-open' ).on( 'click', function( clickEvent ) {
		var $this = $( this );

		$this.addClass( 'active' );

		$( '.site-navigation-container a' ).each( function( index ) {
			var $this = $( this );

			navTimeouts.push( setTimeout( function() {
				$this.addClass( 'active' );
			}, 150 + index * 100 ) );
		} );
	} );

	$( '.site-navigation-control-close' ).on( 'click', function( clickEvent ) {
		var $this = $( this );

		closeMenu();
	} );

	$( '.site-navigation-container a' ).on( 'click', function() {
		closeMenu();
	} );

	$( 'input[name="display"]' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();

		var $this = $( this );
		var value = $this.attr( 'value' );

		if ( value == 'image' ) {
			$( '#list-container' ).addClass( 'd-none' );
			$( '#image-container' ).removeClass( 'd-none' );
			$( window ).scrollTop( $( window ).scrollTop() + 1 );
		} else if ( value == 'list' ) {
			$( '#list-container' ).removeClass( 'd-none' );
			$( '#image-container' ).addClass( 'd-none' );
			$( window ).scrollTop( $( window ).scrollTop() + 1 );
		}
	} );

	$( '.intro-overlay' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();

		var $this = $( this );

		$this.removeClass( 'active' );
		$( 'body' ).removeClass( 'active-intro-overlay' );
	} );

	setTimeout( function() {
		$( '.intro-overlay' ).removeClass( 'active' );
		$( 'body' ).removeClass( 'active-intro-overlay' );
	}, 2500 );

	$( '.gallery a' ).fancybox( {} );

	$( '[data-filter]' ).on( 'click', function( clickEvent ) {
		var $this = $( this );

		var filter = $this.attr( 'data-filter' );

		$( '.filter-item' ).addClass( 'inactive' ).removeClass( 'last-item' );

		$( filter ).removeClass( 'inactive' );

		$( '.filter-item:not(.inactive):last' ).addClass( 'last-item' );

		$( window ).scrollTop( $( window ).scrollTop() + 1 );
	} );
} );

function closeMenu() {
	$( 'body' ).removeClass( 'active-menu' );
	$( '.site-navigation-control, .site-navigation-container' ).removeClass( 'active' );

	$( '.site-navigation-control-open' ).removeClass( 'active' );
	$( '.site-navigation-container a' ).removeClass( 'active' );

	navTimeouts.forEach( function( timeout ) {
		clearTimeout( timeout );
	} );

	navTimeouts = [];
}

/* 3/24/2017 Sanitize_Target_Blank.htm https://gist.github.com/JamoCA/80f65eb07f054b1326221bd4f15868d6 */
function sanitizeTargetBlank() {
	$( 'a[rel~=external]' ).prop( 'target', '_blank' );
	$( 'a[target="_blank"]' ).each( function() {
		var a = $( this );
		if ( location.hostname !== this.hostname ) {
			var originalRel = (this.rel === undefined) ? '' : this.rel.toLowerCase();
			var newRel = originalRel.split( " " );
			if ( originalRel.indexOf( 'noopener' ) === -1 ) {
				newRel.push( 'noopener' );
			}
			if ( originalRel.indexOf( 'noreferrer' ) === -1 ) {
				newRel.push( 'noreferrer' );
			}
			if ( originalRel.indexOf( 'nofollow' ) === -1 ) {
				newRel.push( 'nofollow' );
			}
			a.attr( 'rel', newRel.join( " " ).trim() );
		}
	} );
	console.log( 'External AHREF links have been sanitized.', new Date );
}

function viewRel() {
	var linkLog = [];
	console.log( 'Identifying all AHREF links with target="_blank"...' );
	$( 'a[target="_blank"]' ).each( function( i ) {
		var a = $( this );
		var r = a.attr( 'rel' );
		if ( r !== undefined ) {
			r = r.split( " " );
		}
		var entry = {
			'index': i,
			'linkText': a.text(),
			'href': a.attr( 'href' ),
			'target': a.attr( 'target' ),
			'rel': r
		};
		linkLog.push( entry );
	} );
	console.table( linkLog );
}
